import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'
import { PharmacyComparisonResponse } from '@/types/interfaces/pharmacyComparison'

interface PharmacyComparisonParams {
    skuId: string
    latitude: number
    longitude: number
}

export const pharmacyComparisonApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getPharmacyComparisons: builder.query<PharmacyComparisonResponse, PharmacyComparisonParams>({
            query: ({ skuId, latitude, longitude }) =>
                apiEndpoints.pharmacyComparisons.list(skuId, latitude, longitude),
            // Distinct id per skuId/latitude/longitude combination — a search at a different
            // location or for a different SKU is a different result set, not a cache hit.
            providesTags: (_result, _error, { skuId, latitude, longitude }) => [
                { type: 'PharmacyComparison', id: `${skuId}:${latitude}:${longitude}` },
            ],
        }),
    }),
})

export const { useGetPharmacyComparisonsQuery } = pharmacyComparisonApi
